import htmx from "htmx.org";
window.htmx = htmx;

document.body.addEventListener('htmx:beforeSwap', function(evt) {
    if (evt.detail.xhr.status === 499){
        if (evt.detail.xhr.getResponseHeader("WWW-Authenticate") === 'OIDC') {
            window.location.assign("/");
        }
    }
});

import "htmx-ext-sse";
import "htmx-ext-ws";
